import { Store } from 'vuex';
import { Account } from '@/models/account';
import { isPhotoPending } from '@/lib/constants/photo_status';

export async function refreshStalePhotoData(store: Store<any>, account: Account | null): Promise<void> {
  if (!account || !isPhotoPending(account.photoStatus)) return;

  await store.dispatch('account/fetchAccountData');
}
